














import Component, { mixins } from "vue-class-component";
import { AxiosResponse } from "axios";
import ShowContainer from "@/common/mixin/ShowContainer";
import DetailRow from "@/common/component/DetailRow.vue";
import { locationApi } from "@/context/location/api/LocationApi";
import { LocationShowModel } from "@/context/location/model/LocationShowModel";
import ProgressSpinnerWrapper from "@/common/component/ProgressSpinnerWrapper.vue";

@Component({
  components: { ProgressSpinnerWrapper, DetailRow }
})
export default class LocationShowContainer extends mixins(ShowContainer) {
  model!: LocationShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await locationApi.show(id);
    this.model = response?.data?.view;
  }
}
